import { Button } from 'blaze-ui/Button'
import { AI } from 'blaze-ui/icons'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { GenerateImageDrawer } from 'components/GenerateImageDrawer/GenerateImageDrawer'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useUploadAndInsert } from './useUploadAndInsert'

export const AIGenerateButton = observer(() => {
  const { drawersStore } = useRootStore()
  const { isMobile } = useResponsiveDesign()
  const { uploadAndInsert } = useUploadAndInsert()

  const openImageWizard = () => {
    drawersStore.closeDrawer()

    drawersStore.openDrawer(GenerateImageDrawer, {
      onUse: uploadAndInsert,
    })
  }

  return (
    <Button variant={isMobile ? 'tertiary' : 'primary'} onPress={openImageWizard} frontIcon={AI}>
      Generate Image
    </Button>
  )
})
